import {Suspense, useState} from 'react';
import {EvButton} from '../../form/EvButton';
import {ErrorBoundary} from '../../errorhandling/ErrorBoundary';
import {EvLoadingSpinnerElement} from '../../components/ev-loading-spinner-element';
import {MaterialVariationMachinePreselectForm} from './material-variation-machine-preselect-form';

interface Props {
  variationId: number;
  variationName?: string | null;
}

export function MaterialVariationMachinePreselect(props: Props) {
  const [state, setState] = useState<{ modalState: 'open' | 'closed' }>({modalState: 'closed'});
  return <>
    <EvButton variant="link"
              size="no-padding"
              title="Vorausgewählte Maschinen bearbeiten"
              onClick={() => setState({modalState: 'open'})}>
      <i className="fa fa-gavel"/>
    </EvButton>

    {state.modalState === 'open' &&
      <ErrorBoundary>
        <Suspense fallback={<EvLoadingSpinnerElement/>}>
          <MaterialVariationMachinePreselectForm variationId={props.variationId}
                                                 formSuccess={() => setState({modalState: 'closed'})}/>
        </Suspense>
      </ErrorBoundary>
    }
  </>;
}
